import { Injectable, EventEmitter } from '@angular/core';
import { Router, Event } from '@angular/router';
import { tokenNotExpired } from 'angular2-jwt';
import 'rxjs/add/operator/filter';
import * as auth0 from 'auth0-js';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/take';
import { STORAGE_KEYS } from '../../config/storage-keys';

// Avoid name not found warnings
declare var Auth0Lock: any;

@Injectable()
export class AuthService {
  userProfile: any;
  options = {
    language: 'fr',
    additionalSignUpFields: [{
      name: 'fname',
      placeholder: 'Prénom',
      validator: function (address) {
        return {
          valid: address.length >= 4,
          hint: 'Ne peut être vide' // optional
        };
      }
    },
    {
      name: 'lname',
      placeholder: 'Nom de famille',
      validator: function (address) {
        return {
          valid: address.length >= 4,
          hint: 'Ne peut être vide'
        };
      }
    }]
  };

  lock: any;
  profile: any;
  onProfileUpdated: EventEmitter<any> = new EventEmitter<any>();

  constructor(public router: Router) {
    // Auth Lock Pop Up Registration
    // Add callback for lock `authenticated` event
    this.lock = new Auth0Lock(environment.auth0Config.clientID, environment.auth0Config.domain, this.options);
    this.lock.on('authenticated', (authResult: any) => {
      this.lock.getProfile(authResult.idToken, (error: any, profile: any) => {
        if (error) {
          throw new Error(error);
        }
        const expiresAt = JSON.stringify((authResult['idTokenPayload'].exp * 1000) + new Date().getTime());
        localStorage.setItem('id_token token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);
        // We will wrap the profile into a JSON object as In local Storage you can only store strings
        localStorage.setItem('profile', JSON.stringify(profile));
        this.profile = profile;
        localStorage.setItem('email', this.profile.email);
        localStorage.removeItem('criteria1');
        localStorage.removeItem('vision_title');
        localStorage.removeItem('current_survey');
        localStorage.removeItem('surveys');
      });
    });

    this.lock.on('authorization_error', function (error) {
      this.show({
        flashMessage: {
          type: 'error',
          text: error.error_description
        }
      });
    });
  }

  public static getGraphCoolAuthHeader() {
    return 'Bearer ' + localStorage.getItem(STORAGE_KEYS.gcToken);
  }

  private setSession(authResult): void {
    // Set the time that the access token will expire at
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
  }

  public logout(): void {
    // Remove tokens and expiry time from localStorage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('user_data');
    localStorage.removeItem('email');
    localStorage.removeItem('criteria1');
    localStorage.removeItem('profile');
    localStorage.removeItem('vision_title');
    localStorage.removeItem('current_survey');
    localStorage.removeItem('surveys');

    // Go back to the home route
    this.router.navigate(['/']);
  }

  public isAuthenticated(): boolean {
    // Check whether the current time is past the
    // access token's expiry time
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  public locklogin() {
    // Call the show method to display the widget.
    this.lock.show();
  }
  // Not used
  public authenticated() {
    // Check if there's an unexpired JWT
    // This searches for an item in localStorage with key == 'id_token'
    return tokenNotExpired();
  }

  // Not used
  public locklogout() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('profile');
    this.onProfileUpdated.emit(null); // HUNG
  }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/auth/auth.service.ts